
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import clipboardCopy from "clipboard-copy";
import Icon from "@/components/UI/Icon.vue";
@Component({
  components: { Icon }
})
export default class CopyButton extends Vue {
  @Prop()
  valueToCopy!: string;

  valueCopied = false;
  copyValue() {
    clipboardCopy(this.valueToCopy).then(() => (this.valueCopied = true));
    setTimeout(() => (this.valueCopied = false), 3000);
  }
}
